export const SET_USER_REQUEST_CONTRACT = 'SET_USER_REQUEST_CONTRACT';
